var exports = {
  "i": "xa15a2ab7--f7672d--wrapper",
};

module.exports = exports;
